import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-history\"><path d=\"M512 0C229.23 0 0 229.232 0 512c0 282.77 229.23 512 512 512s512-229.23 512-512C1024 229.232 794.77 0 512 0z m0 943.582C273.644 943.582 80.418 750.355 80.418 512 80.418 273.644 273.644 80.418 512 80.418S943.582 273.644 943.582 512c0 238.355-193.226 431.582-431.582 431.582z\" p-id=\"1966\" /><path d=\"M550.81 501.213V181.1h-80.075v400.531h350.53v-80.076H550.81z\" p-id=\"1967\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol